export default __webpack_public_path__ + "static/Entenda0119-a471aa3559bb90889df8fb5769240903.jpg";